import {
  VIcon
} from 'vuetify/lib'

export default function (h) {
  return h(
    'div',
    {
      style: {
        alignItems: 'center',
        // backgroundColor: '#fff',
        border: `1px dashed rgba(${this.theme.isDark ? '255,255,255,0.7' : '0,0,0,0.54'})`,
        borderRadius: '24px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center'
      },
      on: {
        dragleave: this.onDragLeave,
        dragover: this.onDragOver,
        drop: this.onDrop,
        click: this.onClick
      },
      directives: [{
        name: 'shared-element',
        arg: 'image-input'
      }]
    },
    [
      h(
        'input',
        {
          style: {
            display: 'none'
          },
          attrs: {
            type: 'file'
          },
          on: {
            change: this.onChange
          },
          ref: 'input'
        }
      ),
      h(
        'div',
        {
          class: {
            'd-flex': true,
            'justify-center': true,
            'align-center': true,
            'flex-column': true
          }
        },
        [
          h(
            'span',
            {
              class: {
                'grey--text': true,
                'mb-2': true
              }
            },
            this.label
          ),
          h(
            VIcon,
            {
              style: this.uploadIconStyle,
              props: {
                large: true
              }
            },
            this.uploadIcon
          )
        ]
      )
    ]
  )
}
